import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const HomeIndustries = () => {
    const subheading = "Industries Served";
    const heading = "Empowering Industries with Expert Talent";

    const serviceList = [
        { title: "Information Technology (IT)", description: "From software development to cybersecurity, we provide skilled IT professionals who drive innovation and support your technology needs." },
        { title: "Healthcare", description: "We supply qualified healthcare professionals, including nurses, doctors, and administrative staff, ensuring your facility operates smoothly." },
        { title: "Construction", description: "Our staffing solutions cover skilled laborers, project managers, and engineers to meet project deadlines and quality standards." },
        { title: "Hospitality", description: "We provide a range of hospitality staff, including front-of-house personnel, chefs, and event coordinators, ensuring exceptional service in hotels, restaurants, and events." },
        { title: "Manufacturing", description: "Our staffing solutions include technicians, assembly line workers, and quality control specialists to support your production needs." },
        { title: "Retail", description: "We provide retail staff, including sales associates and inventory managers, to enhance customer experience and optimize store operations." },
        { title: "Finance and Accounting", description: "We connect you with professionals who manage financial operations, from bookkeeping to financial analysis." },
        { title: "Logistics and Supply Chain", description: "We supply logistics and supply chain professionals, including warehouse staff and logistics coordinators, ensuring efficient operations and timely deliveries." },
        { title: "Education", description: "We provide qualified educators and administrative staff to schools and educational institutions, supporting the development of future generations." },
        { title: "Telecommunications", description: "We offer staffing solutions for technicians and customer service representatives to support your communications infrastructure." },
    ];

    const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

    const textRef = useRef(null);
    const isInView = useInView(textRef, { once: true, margin: "-100px" });

    return (
        <>
            <div className="services-main-v9">
                {/* Heading Section */}
                <motion.div
                    ref={textRef}
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.06,
                            },
                        },
                    }}
                >
                    {/* Subheading */}
                    <motion.p className="service-home-subheading-v9">
                        {splitWords(subheading).map(({ word, key }) => (
                            <motion.span
                                key={`sub-${key}`}
                                className="service-page-p"
                                variants={{
                                    hidden: { opacity: 0, y: 15 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.p>

                    {/* Heading */}
                    <motion.h2 className="service-page-h1">
                        {splitWords(heading).map(({ word, key }) => (
                            <motion.span
                                key={`head-${key}`}
                                className="about-home-heading-word-v9"
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.h2>
                </motion.div>

                {/* Service Cards Section */}
                <div className="services-card-container">
                    {serviceList.map((service, index) => (
                        <motion.div
                            key={index}
                            className="service-card"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <h3 className="service-card-title">{service.title}</h3>
                            <p className="service-card-description">{service.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default HomeIndustries;
